"use strict";

var _classCallCheck = require("/home/gitlab-runner/builds/o6jZzivs/0/root/rf-kiln/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Point = void 0;

var Point = function Point(position, particle) {
  _classCallCheck(this, Point);

  this.position = position;
  this.particle = particle;
};

exports.Point = Point;